"use strict";

exports.__esModule = true;
exports.Button = void 0;

var _Button = require("./Button");

var _CheckableButton = require("./CheckableButton");

var _Group = require("./Group");

var Button = Object.assign(_Button.Button, {
  Group: _Group.Group,
  Checkable: _CheckableButton.CheckableButton
});
exports.Button = Button;